/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { TextField, List, ListItem, ListItemText, Paper } from '@mui/material';


const COLORS = {
  B: '#110C0E',
  W: '#EDE5D3',
  U: '#AFD8EF',
  G: '#A2CBA9',
  R: '#F3A992',
  C: '#777777'
}
const SearchBar = ({cardNames, setSearched, phone}) => {
  const [query, setQuery] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const white = '#EDE5D3';
  const blue = '#AFD8EF';
  const red = '#F3A992';
  const green = '#A2CBA9';
  const black = '#110C0E';

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value) {
      setFilteredSuggestions(
        cardNames.filter((suggestion) =>
          suggestion.name.toLowerCase().includes(value.toLowerCase())
        ).slice(0, phone ? 5 : 10)
      );
    } else {
      setFilteredSuggestions([]);
    }
    setActiveSuggestionIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      if (activeSuggestionIndex < filteredSuggestions.length - 1) {
        setActiveSuggestionIndex(activeSuggestionIndex + 1);
      }
    } else if (e.key === 'ArrowUp') {
      if (activeSuggestionIndex > 0) {
        setActiveSuggestionIndex(activeSuggestionIndex - 1);
      }
    } else if (e.key === 'Enter') {
      if (activeSuggestionIndex >= 0) {
        setSearched(filteredSuggestions[activeSuggestionIndex])
        setQuery('');
        setFilteredSuggestions([]);
        setActiveSuggestionIndex(-1);
      }
    }
  };

  const handleClick = (suggestion) => {
    setSearched(suggestion)
    setQuery('');
    setFilteredSuggestions([]);
    setActiveSuggestionIndex(-1);
  };

  return (
    <div className="App">
      <div className="search-bar-container">
        <input 
          type="text" 
          value={query} 
          onChange={handleChange} 
          onKeyDown={handleKeyDown}
          placeholder='Card name'
          className="search-bar"
          style={{backgroundColor: '#fbfaf2', borderWidth: '3px', 
            color: 'black',
            fontSize: '13px',
            fontFamily: 'Montserrat, sans-serif',
        }}
        />
        {filteredSuggestions.length > 0 && (
          <ul className="suggestions">
            {filteredSuggestions.map((suggestion, index) => (
              <>
                <li key={index} 
                    onClick={() => handleClick(suggestion)} 
                    className={index === activeSuggestionIndex ? 'active' : ''}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{width: '90%', overflow: 'hidden'}}>
                      {suggestion.name}
                      </div>
                      <div style={{width: '25%'}}>
                {Array.from(suggestion.colors).map((t, i) => {
                  return (<span style={{display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: COLORS[t],
                    }}></span>)
                    })}
                        </div>
                  </li>
              </>
            ))}
          </ul>
        )}
      </div>
      <canvas id="myCanvas"></canvas>
    </div>
  );

  // return (
  //   <div style={{alignContent: 'left'}}>
  //     <TextField
  //       label="Search"
  //       variant="outlined"
  //       value={query}
  //       autoComplete='off'
  //       onChange={handleChange}
  //       onKeyDown={handleKeyDown}
  //       style={{width: '20%'}}
  //     />
  //     {filteredSuggestions.length > 0 && (
  //       <Paper >
  //         <List>
  //           {filteredSuggestions.map((suggestion, index) => (
  //             <ListItem
  //               button
  //               key={index}
  //               onClick={() => handleClick(suggestion)}
  //               selected={index === activeSuggestionIndex}
  //               style={{width: '20%', display: 'flex'}}
  //             >
  //               <ListItemText primary={suggestion.name} />
  //             </ListItem>
  //           ))}
  //         </List>
  //       </Paper>
  //     )}
  //   </div>
  // );
};

export default SearchBar;
